import React, { useState } from "react";

import { Title } from "..";
import "./faq.css";

const questions = [
  {
    question: "Who are the courses for?",
    answer: "Our courses are made for curious learners at different stages, whether you are starting from scratch or building on what you already know.",
  },
  {
    question: "Do I need previous experience?",
    answer: "Most courses are beginner-friendly. Each course page explains the recommended starting level so you can choose with confidence.",
  },
  {
    question: "What will I learn?",
    answer: "You will learn useful concepts through guided lessons and practical activities, with a focus on skills you can apply beyond the classroom.",
  },
  {
    question: "How do I choose the right course?",
    answer: "Start with the course that matches your interests and goals. You can compare the available options on our Courses page or contact us for guidance.",
  },
];

const Faq = () => {
  const [openQuestion, setOpenQuestion] = useState(0);

  const toggleQuestion = (index) => {
    setOpenQuestion((current) => (current === index ? -1 : index));
  };

  return (
    <section className="faq-section" aria-label="Frequently asked questions">
      <div className="container">
        <Title
          title="Frequently asked questions"
          subtitle="A few answers before you get started"
        />
        <div className="faq-list">
          {questions.map((item, index) => {
            const isOpen = openQuestion === index;
            const answerId = `faq-answer-${index}`;

            return (
              <div className={`faq-item${isOpen ? " is-open" : ""}`} key={item.question}>
                <button
                  className="faq-question"
                  type="button"
                  aria-expanded={isOpen}
                  aria-controls={answerId}
                  onClick={() => toggleQuestion(index)}
                >
                  <span>{item.question}</span>
                  <span className="faq-icon" aria-hidden="true">{isOpen ? "-" : "+"}</span>
                </button>
                <div className="faq-answer" id={answerId} hidden={!isOpen}>
                  <p>{item.answer}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Faq;
